/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuccessResponse_WeeklyReportHistory_ } from '../models/SuccessResponse_WeeklyReportHistory_';
import type { SuccessResponse_WeeklyReportRow_ } from '../models/SuccessResponse_WeeklyReportRow_';
import type { SuccessResponse_WeeklyReportWorkspace_ } from '../models/SuccessResponse_WeeklyReportWorkspace_';
import type { WeeklyReportArchiveRequest } from '../models/WeeklyReportArchiveRequest';
import type { WeeklyReportDraftWrite } from '../models/WeeklyReportDraftWrite';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WeeklyReportsService {
    /**
     * Get Weekly Report Workspace Endpoint
     * @returns SuccessResponse_WeeklyReportWorkspace_ Successful Response
     * @throws ApiError
     */
    public static getWeeklyReportWorkspaceEndpointApiV1WeeklyReportsGet({
        storeId,
        weekStart,
    }: {
        storeId: number,
        weekStart?: (string | null),
    }): CancelablePromise<SuccessResponse_WeeklyReportWorkspace_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/weekly-reports',
            query: {
                'store_id': storeId,
                'week_start': weekStart,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Save Weekly Report Draft Endpoint
     * @returns SuccessResponse_WeeklyReportRow_ Successful Response
     * @throws ApiError
     */
    public static saveWeeklyReportDraftEndpointApiV1WeeklyReportsStoreIdWeekStartDraftPut({
        storeId,
        weekStart,
        requestBody,
    }: {
        storeId: number,
        weekStart: string,
        requestBody: WeeklyReportDraftWrite,
    }): CancelablePromise<SuccessResponse_WeeklyReportRow_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/weekly-reports/{store_id}/{week_start}/draft',
            path: {
                'store_id': storeId,
                'week_start': weekStart,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Archive Weekly Report Endpoint
     * @returns SuccessResponse_WeeklyReportRow_ Successful Response
     * @throws ApiError
     */
    public static archiveWeeklyReportEndpointApiV1WeeklyReportsStoreIdWeekStartArchivePost({
        storeId,
        weekStart,
        requestBody,
    }: {
        storeId: number,
        weekStart: string,
        requestBody: WeeklyReportArchiveRequest,
    }): CancelablePromise<SuccessResponse_WeeklyReportRow_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/weekly-reports/{store_id}/{week_start}/archive',
            path: {
                'store_id': storeId,
                'week_start': weekStart,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Weekly Report Revision Endpoint
     * @returns SuccessResponse_WeeklyReportRow_ Successful Response
     * @throws ApiError
     */
    public static createWeeklyReportRevisionEndpointApiV1WeeklyReportsStoreIdWeekStartRevisionsPost({
        storeId,
        weekStart,
    }: {
        storeId: number,
        weekStart: string,
    }): CancelablePromise<SuccessResponse_WeeklyReportRow_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/weekly-reports/{store_id}/{week_start}/revisions',
            path: {
                'store_id': storeId,
                'week_start': weekStart,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Weekly Report History Endpoint
     * @returns SuccessResponse_WeeklyReportHistory_ Successful Response
     * @throws ApiError
     */
    public static getWeeklyReportHistoryEndpointApiV1WeeklyReportsStoreIdWeekStartHistoryGet({
        storeId,
        weekStart,
    }: {
        storeId: number,
        weekStart: string,
    }): CancelablePromise<SuccessResponse_WeeklyReportHistory_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/weekly-reports/{store_id}/{week_start}/history',
            path: {
                'store_id': storeId,
                'week_start': weekStart,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
